import { render, staticRenderFns } from "./MyReservationItem.vue?vue&type=template&id=617b5d84&scoped=true&"
import script from "./MyReservationItem.vue?vue&type=script&lang=ts&"
export * from "./MyReservationItem.vue?vue&type=script&lang=ts&"
import style0 from "./MyReservationItem.vue?vue&type=style&index=0&id=617b5d84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617b5d84",
  null
  
)

export default component.exports